import type { Messages } from "../types";

export const messages: Messages = {
  shared: {
    title: "Fielmann Kundenkonto",
    tabs: {
      login: "Einloggen",
      signup: "Konto erstellen",
      ariaLabel: "Authentifizierung",
    },
    languageSwitcher: {
      label: "Sprache auswählen",
    },
    password: {
      show: "Passwort anzeigen",
      hide: "Passwort verbergen",
    },
    header: {
      logoAriaLabel: "Fielmann",
    },
    footer: {
      ariaLabel: "Fusszeile",
      customerService: "Kundenservice",
      legalNotice: "Impressum",
      dataProtection: "Datenschutz",
    },
    loading: {
      ariaLabel: "Einen Augenblick, bitte...",
      content: "Inhalte werden geladen.",
    },
  },
  login: {
    subtitle: "Logge dich mit deiner E-Mail und deinem Passwort ein.",
    form: {
      emailLabel: "E-Mail *",
      passwordLabel: "Passwort *",
      forgotPassword: "Passwort vergessen?",
      submitButton: "Einloggen",
      credentialError: "E-Mail und Passwort passen nicht zusammen.",
      genericError:
        "Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
    },
  },
  signup: {
    subtitle: {
      before: "Nutze die ",
      highlight: "Vorteile",
      after: " und erstelle dein Fielmann Kundenkonto.",
    },
    benefits: {
      popoverHeading: "Deine Vorteile:",
      closeLabel: "Schliessen",
      items: {
        orders:
          "Alle Fielmann Bestellungen inklusive Bestellstatus auf einen Blick.",
        visionValues: "Sehwerte für die nächste Bestellung übernehmen.",
        appointments: "Termine buchen und verwalten.",
        reorders: "Nachbestellungen ganz einfach online erledigen.",
      },
    },
    form: {
      firstNameLabel: "Vorname *",
      lastNameLabel: "Nachname *",
      emailLabel: "E-Mail *",
      passwordLabel: "Passwort *",
      passwordRepeatLabel: "Passwort wiederholen *",
      submitButton: "Konto erstellen",
      errorTitle: "Das Konto konnte nicht erstellt werden.",
      errorMessage:
        "Bitte überprüfe deine Eingaben oder versuche es später noch einmal.",
      genericError:
        "Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
    },
    consents: {
      requiredError: "Bitte stimme der erforderlichen Einwilligung zu.",
      unavailableError:
        "Es ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
      required: {
        headline: "Zustimmung zum Kundenkonto",
        subline:
          "Damit wir dir alle Inhalte in deinem Kundenkonto anzeigen können (z.B. Käufe oder Termine), brauchen wir deine Zustimmung.",
      },
      optional: {
        headline: "Möchtest du personalisierte Werbung erhalten?",
        subline:
          "Du hast die Wahl: Mit der Zustimmung erhältst du auf dich zugeschnittene Angebote und Informationen. Ohne Zustimmung nutzt du dein Kundenkonto ohne personalisierte Werbung.",
      },
    },
  },
  emailVerification: {
    subtitle: "Du kannst dich nicht einloggen?",
    alertTitle: "Bestätige erst deine E-Mail-Adresse.",
    alertBody:
      "Bitte bestätige zuerst deine E-Mail-Adresse, um dein Fielmann Konto zu aktivieren.",
    alertSpamHint:
      "Du findest die E-Mail nicht? Schau auch im Spam-Ordner nach.",
    resendButton: "E-Mail erneut anfordern",
    backToLogin: "Zurück zum Einloggen",
  },
  setPassword: {
    subtitle: "Du kannst jetzt dein Passwort festlegen.",
    emailLabel: "E-Mail *",
    passwordLabel: "Passwort *",
    passwordRepeatLabel: "Passwort wiederholen *",
    submitButton: "Passwort speichern",
    backToLogin: "Zum Einloggen",
    successTitle: "Dein Passwort wurde erfolgreich gespeichert.",
    successBody: "Du kannst dich jetzt einloggen.",
  },
  toasts: {
    missingRequiredFields:
      "Bitte fülle alle noch fehlenden Pflichtfelder aus, um fortzufahren.",
  },
  validation: {
    passwordRequired: "Bitte gib ein Passwort ein.",
    passwordRepeatRequired: "Bitte gib das Passwort erneut ein.",
    firstNameTooLong: "Der Vorname darf nicht länger als 30 Zeichen sein.",
    firstNameRequired: "Bitte gib einen Vornamen ein.",
    firstNameInvalidFormat: "Bitte gib einen gültigen Vornamen ein.",
    lastNameTooLong: "Der Nachname darf nicht länger als 30 Zeichen sein.",
    lastNameRequired: "Bitte gib einen Nachnamen ein.",
    lastNameInvalidFormat: "Bitte gib einen gültigen Nachnamen ein.",
    emailTooLong: "Die E-Mail-Adresse ist zu lang.",
    emailRequired: "Bitte gib eine E-Mail-Adresse ein.",
    emailInvalidFormat: "Bitte gib eine gültige E-Mail-Adresse ein.",
    passwordMatchesEmail:
      "Das Passwort darf nicht mit der E-Mail-Adresse übereinstimmen.",
    passwordMismatch: "Die Passwörter stimmen nicht überein.",
  },
  passwordRequirements: {
    minimumLength: "Mindestens 10 Zeichen",
    mixedCase: "Mindestens ein Gross- und ein Kleinbuchstabe",
    hasNumber: "Mindestens eine Zahl",
    specialCharactersAllowed: "Sonderzeichen sind erlaubt (z. B. !@#$%^&*)",
  },
};
